<template>
    <div>
        <el-card :key="index" v-for="(painspot, index) in painspot_list" style="margin-top:20px;text-align:left;margin-left:50px;width:800px;" shadow="hover">
            <div style="width:800px;">
                <div style="float:left;width:660px;" @click="show_article_details(painspot)" class="card_css">
                    <p>文章所在目录</p>
                    <p style="font-weight:bold;font-size:22px;">{{ painspot.title }}</p>
                    <p>{{ painspot.desc }}</p>
                    <p>更新时间：{{ painspot.update_time }} | 评分：{{ painspot.rank }}</p>
                </div>
                <div style="float:left;width:120px;text-align:center;margin-top:70px;">
                    <span v-if="painspot.status=='已发布'"><i class="el-icon-success" style="color:#67C23A;" /><span style="margin-left:5px;">已发布</span></span>
                    <span v-if="painspot.status=='待审核'"><i class="el-icon-warning" style="color:#E6A23C;" /><span style="margin-left:5px;">待审核</span></span>
                    <span v-if="painspot.status=='已驳回'"><i class="el-icon-error" style="color:#F56C6C" /><span style="margin-left:5px;">已驳回</span></span>
                    <div style="margin-top:5px;" v-if="painspot.status=='已驳回'"><el-button type="primary" size="mini" @click="show_reason(painspot.remark)">查看原因</el-button></div>
                </div>
            </div>
        </el-card>
        <el-dialog
          :visible.sync="dialogVisible"
          :fullscreen="true"
          :show-close="false"
          custom-class="fullscreen-dialog"
          @opened="handleDialogOpened">
          <template #title>
            <div class="dialog-header">
              <span style="font-size:25px;">{{ cur_info.title }}</span>
              <el-button
                class="close-btn"
                icon="el-icon-close"
                @click="dialogVisible = false"
              ></el-button>
            </div>
          </template>

          <div class="dialog-content">
            <div style="text-align:left;margin-left:20px;">
              <span>更新时间：{{ cur_info.update_time }}</span><span style="margin-left:20px;">评分：{{ cur_info.avg_rating }}</span>
            </div>
            <!-- <div style="text-align:left;margin-left:20px;display:flex;margin-top:10px;">
              <el-button type="text" icon="el-icon-star-off" v-if="cur_info.isfavorite!='是'" @click="collect_painspot('add')">收藏</el-button>
              <el-button type="text" icon="el-icon-star-on" v-else @click="collect_painspot('remove')">收藏</el-button>
              <el-button type="text" icon="el-icon-s-comment" style="margin-left:10px;" @click="rating_painspot">评分</el-button>
              <el-rate
                v-model="cur_info.rating"
                show-score
                allow-half
                :disabled="cur_info.rating>0"
                text-color="#ff9900"
                style="margin-top:10px;margin-left:10px;"
                v-show="show_rating || cur_info.rating > 0"
                @change="submitRating">
              </el-rate>
              <el-button type="text" icon="el-icon-share" style="margin-left:10px;">分享</el-button>
              <el-button type="text" icon="el-icon-edit" style="margin-left:10px;" @click="editRichText" v-if="!isEdit && logged_role=='expert'">编辑</el-button>
              <el-button type="text" icon="el-icon-setting" style="margin-left:10px;" @click="saveRichText" v-if="isEdit && logged_role=='expert'">保存</el-button>
            </div> -->
            <div class="ql-editor" v-html="content" style="margin-top:15px;" v-show="!isEdit"></div>
            <!-- <div class="editor-container" style="margin-top:15px;" v-show="isEdit && logged_role=='expert'">
              <quill-editor
                v-model="content"
                ref="myQuillEditor"
                :options="editorOptions"
              />
            </div> -->
          </div>
          <!-- <div class="dialog-content" v-show="content_permit==false">
            <div style="width:100%;text-align:center;padding-top:20%;">
              <span style="font-size:22px;color:#F56C6C;font-weight:500;"><i class="el-icon-warning" /><span style="margin-left:5px;">对不起，你暂无权限访问此内容</span></span>
            </div>
          </div> -->
        </el-dialog>
        <div style="width:100%;text-align:center;padding-top:20%;" v-if="painspot_list.length==0">
            <span style="font-size:22px;color:#F56C6C;font-weight:500;">内容列表为空！</span>
        </div>
    </div>
</template>

<script>
// import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import postdata from "@/api/postData.js";
import getdata from "@/api/getData.js";

export default {
//   components: { quillEditor },
  created() {
    let params = {
        task_type: "GLYF",
    }
    getdata.getListP("checklogin", params)
    .then(resp => {
        this.logged_role = resp.data.utype;
    })
    .catch(() => {
        this.logged_role = 'guest';
    })
    this.getMyContentList();
  },
  data() {
    return {
        painspot_list: [],
        // painspot_list: [
        // {'title': 'title1', 'desc': 'desc1', 'update_time': '2025/04/26 18:41:00', 'rank': '4.3/5', 'status': '已发布'}, 
        // {'title': 'title2', 'desc': 'desc2', 'update_time': '2025/04/25 15:31:00', 'rank': '4.9/5', 'status': '待审核'},
        // {'title': 'title3', 'desc': 'desc3', 'update_time': '2025/04/27 12:35:00', 'rank': '4.5/5', 'status': '已驳回'},],
        content: '',
        isEdit: false,
        editorOptions: {
            modules: {
            toolbar: [
                ['bold', 'italic', 'underline', 'strike'],
                ['blockquote', 'code-block'],
                [{ 'header': 1 }, { 'header': 2 }],
                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                [{ 'script': 'sub' }, { 'script': 'super' }],
                [{ 'indent': '-1' }, { 'indent': '+1' }],
                [{ 'direction': 'rtl' }],
                [{ 'size': ['small', false, 'large', 'huge'] }],
                [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                [{ 'color': [] }, { 'background': [] }],
                [{ 'font': [] }],
                [{ 'align': [] }],
                ['link'],
                ['clean']
            ]
            },
            placeholder: '请输入内容...',
            theme: 'snow',
        },
        cur_info: {},
        dialogVisible: false,
        // content_permit: true,
        logged_role: 'guest',
    }
  },
  methods: {
    show_reason(reason) {
        this.$alert(reason, '原因', {
        confirmButtonText: '知道了',
        });
    },
    getMyContentList() {
        getdata.getList("getExpertContributionList")
            .then(resp => {
                if(resp.data.code == 200){
                    this.painspot_list = resp.data.data;         
                }
            })
            .catch(err => {
                console.log(err);
            });
    }, 
    getContributedContent(id) {
        let params;
        params = {
            id: id,
        }
        
        getdata.getListP("getExpertContributedContent", params)
        .then(resp => {
            if(resp.data.code == 200){
                // this.content_permit = true;
                this.content = resp.data.data;
                this.dialogVisible = true;                  
            }else{
                this.$message({
                    message: resp.data.message,
                    type: 'error',
                    duration: 6000,
                })
            }
            // else{
            //     this.content_permit = false;
            //     this.dialogVisible = true;
            // }
        })
        .catch(err => {
            console.log(err);
        });
    },
    submitRating() {
        let params;
        params = {
            pid: this.cur_info.id,
            rate: this.cur_info.rating,
        }
        getdata.getListP("ratingPainSpot", params)
        .then(resp => {
            if(resp.data.code == 200){
                this.getUserFavorites();   // 修改收藏状态或是增加评分时，需要实时刷新痛点列表
            }else{
                this.$message({
                message: resp.data.message,
                type: "error",
                duration: 6000,
                })
            }
        })
        .catch(err => {
            console.log(err);
        });
    },
    collect_painspot(type) {
        let params;
        params = {
            pid: this.cur_info.id,
            opt: type,
        }
        getdata.getListP("switchPainSpotFavorite", params)
        .then(resp => {
            if(resp.data.code == 200){
                if(this.cur_info.isfavorite=='是'){
                this.cur_info.isfavorite = '否';
                }else{
                this.cur_info.isfavorite = '是';
                } 
                this.getUserFavorites();   // 修改收藏状态或是增加评分时，需要实时刷新痛点列表                 
            }else{
                this.$message({
                message: resp.data.message,
                type: "error",
                duration: 6000,
                })
            }
        })
        .catch(err => {
            console.log(err);
        });
    },
    show_article_details(painspot) {
        this.cur_info = painspot;
        this.content = '';
        this.getContributedContent(this.cur_info.id);
    },
    handleDialogOpened() {
        this.$nextTick(() => {
            // 新增粘贴事件监听
            const quill = this.$refs.myQuillEditor.quill;
            this.editor = quill.root;
            this.toolbar = quill.getModule('toolbar');
            this.editor.removeEventListener('paste', this.handlePasteImage);
            this.editor.addEventListener('paste', this.handlePasteImage);
            // 上传文件的监听
            this.$refs.myQuillEditor.quill.getModule('toolbar').addHandler('image', this.imageHandler);
        })
    },
    editRichText() {
    // 启动编辑后需要同步修改后台状态(编辑中)和创建专家贡献记录
    let params;
    params = {
        pid: this.cur_info.id,
    }
    getdata.getListP("addExpertEdit", params)
    .then(resp => {
        if(resp.data.code == 200){
            this.isEdit = true;
        }else{
            this.$message({
            message: resp.data.message,
            type: "error",
            duration: 6000,
            })
        }
    })
    .catch(err => {
        console.log(err);
    });      
    this.$nextTick(() => {
        this.$refs.middleDiv.scrollTop = 0;
    })
    },
    saveRichText() {
    // 提交编辑后需要同步修改后台状态(审核中)
    let params;
    params = {
        pid: this.cur_info.id,
    }
    postdata.postListP("saveExpertEdit", JSON.stringify({'content': this.content}), params)
    .then(resp => {
        if(resp.data.code == 200){
            this.isEdit = false;
        }else{
            this.$message({
            message: resp.data.message,
            type: "error",
            duration: 6000,
            })
        }
    })
    .catch(err => {
        console.log(err);
    });     
    this.$nextTick(() => {
        this.$refs.middleDiv.scrollTop = 0;
    })
    },
    onEditorBlur() { /* 失去焦点处理 */ },
    onEditorChange() { /* 内容变化处理 */ },
    // 图片上传处理
    imageHandler() {
        const input = document.createElement('input')
        input.setAttribute('type', 'file')
        input.click()
        
        input.onchange = async () => {
            const file = input.files[0]
            const formData = new FormData()
            formData.append('image', file)

            // 调用后端上传接口
            const { data } = await postdata.uploadFiles('uploadImages', formData)
            const quill = this.$refs.myQuillEditor.quill
            const range = quill.getSelection()
            quill.insertEmbed(range.index, 'image', data.url)
        }
    },
    // 新增粘贴图片处理方法
    async handlePasteImage(event) {
        const items = (event.clipboardData || event.originalEvent.clipboardData).items;
        let blob = null;

        for (const item of items) {
            if (item.type.indexOf('image') === 0) {
            blob = item.getAsFile();
            break;
            }
        }

        if (blob) {
            event.preventDefault();
            const formData = new FormData();
            formData.append('image', blob);
            
            try {
            const { data } = await postdata.uploadFiles('uploadImages', formData, {
                headers: {
                'Content-Type': 'multipart/form-data'
                }
            });
            
            const quill = this.$refs.myQuillEditor.quill;
            const range = quill.getSelection();
            quill.insertEmbed(range.index, 'image', data.url);
            } catch (error) {
            console.error('图片上传失败:', error);
            }
        }
    },
  }
}
</script>

<style scoped>
.card_css:hover {
  cursor: pointer;
}
/* 【重要！】ql-editor 自带overflow，通过调整这里的height去自适应页面高度 */
.ql-editor {
  height: calc(100vh - 80px - 200px) !important;
}
::v-deep .editor-container .ql-editor {
  height: calc(100vh - 80px - 300px) !important;
}
</style>